import Swal from 'sweetalert2';
import { AxInit, ModuleName } from '../../Lib/AxSystem/AxInit';
import { AxLoad } from '../../Lib/AxSystem/AxLoad';
import { I18nHelper, Translations } from '../../Lib/Helper/I18nHelper';
import { AxLimeStone } from '../../Limestone/AxLimeStone';
import { AxStaticConfigModule } from '../../Modules/AxConfig/AxStaticConfigModule';
import { AxPixelTracking } from '../../Modules/AxMetaTracking/AxPixelTracking';

@ModuleName("AxFireShoppingCartModal")
export class AxFireShoppingCartModal implements AxInit {
    private _i18nHelper = new I18nHelper();
    private result: any;
    private continueShoppingPath: any;
    private btn: any;
    private resetQuantity: boolean;
    private static sArray: string[] =  window.location.pathname.split('/');
    private static baseUrl: string = `${window.location.protocol}//${window.location.host}/${AxFireShoppingCartModal.sArray[1]}/`;
    private static shoppingCartUrl: string = AxFireShoppingCartModal.baseUrl + 'ShoppingCart';
    private queryAddition: string;

    constructor(private LimeStone = new AxLimeStone()) { }

    AxInit(init: AxFireShoppingCartInitData): void {
        this.resetQuantity = init.resetQuantity;
        this.result = init.result;
        this.continueShoppingPath = init.continueShoppingPath;
        this.btn = init.btn;
        this.queryAddition = init.queryAddition || '';
        this.LimeStone.LockButton(this.btn);
        this.fireShoppingCart(this.result, this.resetQuantity ? false : true, this.continueShoppingPath);
        this.LimeStone.UnlockButton(this.btn);
    }

    fireShoppingCart(result, resetQuantity, continueShoppingPath) {
        resetQuantity = resetQuantity || false;
        continueShoppingPath = continueShoppingPath || '';
        let configModule = AxLoad.GetModule<AxStaticConfigModule>('AxStaticConfigModule');

        $('body').on('goToShoppingCartRedirect', (_, route) => {
            window.location.href = route;
        });

        if (result.success == true) {
            const redirect = AxFireShoppingCartModal.shoppingCartUrl + this.queryAddition;

            const axPixelTracking = new AxPixelTracking();
            axPixelTracking.AxInit({
                action: 'addToCart',
            });

            AxLoad.LoadModule('AxGA4Module', {
                caller: 'Add to Cart',
                event: 'Add to Cart',
                redirect,
            });

            if (resetQuantity) {
                $(".store-checkbox").val($('.store-checkbox option:first').val());
            }

            if (!configModule.skipAddedToCartPopup) {
                $('.cartConfirmation-modal').modal({ backdrop: 'static', keyboard: false })
                $('.cartConfirmation-modal').modal("show");

                $('.ax-shoppingcart-goto-btn').on('click', () => {
                    $('body').trigger('goToShoppingCartRedirect', redirect);
                });
                $('.ax-addmore-goto-btn').on('click', () => {
                    window.location.href = this.getContinueShoppingUrl(continueShoppingPath);
                });
            }
        } else {
            this.LimeStone.UnlockAllButtons();
            let title = this._i18nHelper.GetTranslation(Translations.Error);
            if (typeof result.ErrorTitle !== 'undefined') {
                title = result.ErrorTitle;
            }
            Swal.fire({
                title,
                text: 'error',
                html: result.message,
                customClass: {
                    closeButton: 'ax-btn ax-btn-secondary',
                    confirmButton: 'ax-btn ax-btn-primary',
                },
                confirmButtonText: 'Ok',
                width: "40%",
            });
        }
    }

    getContinueShoppingUrl(continuePath) {
        switch (continuePath) {
            case 'Tickets':
                return AxFireShoppingCartModal.baseUrl + 'Tickets';
            case 'Rental':
                return AxFireShoppingCartModal.baseUrl + 'Rental';
            case 'Lessons':
                return AxFireShoppingCartModal.baseUrl + 'Lessons';
            case 'Retail':
                return AxFireShoppingCartModal.baseUrl + 'Retail';
            case 'GiftCards':
                return AxFireShoppingCartModal.baseUrl + 'GiftCards';
            case 'Packages':
                return AxFireShoppingCartModal.baseUrl + 'Packages';
            case 'Products':
                return AxFireShoppingCartModal.baseUrl + 'Products';
            default:
                return AxFireShoppingCartModal.baseUrl + 'Home';
        }
    }
}

interface AxFireShoppingCartInitData {
    result: any;
    continueShoppingPath: any;
    queryAddition: string;
    btn: any;
    resetQuantity?: boolean;
}